import React, { useEffect, useRef, useState } from 'react';
import cls from 'classnames'; // import LeftArrow from './images/LeftArrow.svg';
// import RightArrow from './images/RightArrow.svg';

import LeftArrow from './images/left.svg';
import RightArrow from './images/right.svg';
import styles from './index.module.scss';
import Indicator from '@/components/Indicator';
import { _isPC } from '@/utils/env';
import { throttle } from 'lodash';

const Transform = ({
  children,
  showArrow = 'always',
  slideClassName,
  moveSpeed = 500,
  onChange,
  timingFunc = 'cubic-bezier(0.34, 0.69, 0.1, 1)',
  interval = 5000
}) => {
  const childLength = React.Children.count(children);
  const [slideDirection, setSlideDirection] = useState('none');
  const [slideMode, setSlideMode] = useState('pc');
  const refAnimationTimer = useRef(null);
  const refInterval = useRef(null);
  const refNegative = useRef(false);
  const refStopInterval = useRef(interval <= 0);
  const containerRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const slideTo = (isNegative = false, isManual = false, target = -1) => {
    const oriCurrent = currentIndex;
    let targetIndex = 0;

    if (target >= 0) {
      targetIndex = target;
    } else if (isNegative) {
      targetIndex = oriCurrent === 0 ? childLength - 1 : oriCurrent - 1;
    } else if (!isNegative) {
      targetIndex = oriCurrent === childLength - 1 ? 0 : oriCurrent + 1;
    }

    if (!refAnimationTimer.current && targetIndex >= 0 && targetIndex < childLength) {
      if (isManual && refInterval.current) {
        refStopInterval.current = true;
        window.clearInterval(refInterval.current);
      }

      setSlideDirection(isNegative ? 'negative' : 'positive');
      setCurrentIndex(targetIndex);
      onChange === null || onChange === void 0 ? void 0 : onChange(targetIndex, oriCurrent);
      refAnimationTimer.current = window.setTimeout(() => {
        setSlideDirection('none');
        refAnimationTimer.current = null;
      }, moveSpeed);
    }
  }; // 用于slideMode为mobile时的滚动


  const scrollTo = idx => {
    const container = containerRef.current;
    const scrollWidth = (container === null || container === void 0 ? void 0 : container.scrollWidth) || 0;
    const itemWidth = scrollWidth / childLength;
    const left = idx * itemWidth;
    container === null || container === void 0 ? void 0 : container.scrollTo({
      left,
      behavior: 'smooth'
    });
  };

  let slideStyle = {};

  if (slideMode === 'pc') {
    slideStyle = Object.assign({
      transitionTimingFunction: timingFunc,
      transform: `translateX(calc(${currentIndex * -100}% - ${currentIndex * 8}px))` // animationTimingFunction: timingFunc,
      // animationDuration: `${moveSpeed}ms`,

    }, slideDirection !== 'none' ? {
      transitionDuration: `${moveSpeed}ms`
    } : {});
  }

  useEffect(() => {
    if (!refStopInterval.current && interval && _isPC(navigator.userAgent)) {
      refInterval.current = window.setTimeout(() => {
        if (currentIndex === 0) {
          refNegative.current = false;
        }

        if (currentIndex === childLength - 1) {
          setCurrentIndex(childLength - 1);
          refNegative.current = false;
        }

        slideTo(refNegative.current);
      }, interval);
    }

    return () => {
      if (refInterval.current) {
        window.clearTimeout(refInterval.current);
      }
    };
  }, [interval, slideTo]);
  useEffect(() => {
    const container = containerRef.current;
    const scrollWidth = (container === null || container === void 0 ? void 0 : container.scrollWidth) || 0;
    const containerRect = container === null || container === void 0 ? void 0 : container.getBoundingClientRect();
    const itemWidth = scrollWidth / childLength;
    const handleScroll = throttle(() => {
      if (container && containerRect) {
        let index = Math.floor((container.scrollLeft + containerRect.width / 2) / itemWidth);

        if (container.scrollLeft < 10) {
          index = 0;
        } else if (scrollWidth - (container.scrollLeft + containerRect.width) < 10) {
          index = childLength - 1;
        }

        if (index !== currentIndex) {
          setCurrentIndex(index);
        }

        setSlideMode('mobile');
      }
    }, 200);
    const handleResize = throttle(() => {
      if (window.innerWidth <= 600) {
        setSlideMode('mobile');
      } else {
        setSlideMode('pc');
        container === null || container === void 0 ? void 0 : container.scrollTo({
          left: 0
        });
      }
    }, 200);
    container === null || container === void 0 ? void 0 : container.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    return () => {
      container === null || container === void 0 ? void 0 : container.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [containerRef, childLength, currentIndex, setCurrentIndex, setSlideMode]);

  const handleChange = idx => {
    if (currentIndex === idx) {
      return;
    }

    if (slideMode === 'mobile') {
      scrollTo(idx);
    } else {
      slideTo(currentIndex > idx, true, idx);
    }
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.slideWraper
  }, /*#__PURE__*/React.createElement(LeftArrow, {
    className: cls(styles.arrowLeft),
    onClick: () => slideTo(true, true)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.container,
    ref: containerRef
  }, /*#__PURE__*/React.createElement("div", {
    className: cls(styles.slide, slideClassName),
    style: slideStyle
  }, children, /*#__PURE__*/React.createElement("div", {
    className: styles.white
  }))), /*#__PURE__*/React.createElement(RightArrow, {
    className: cls(styles.arrowRight),
    onClick: () => slideTo(false, true)
  })), childLength > 1 && /*#__PURE__*/React.createElement(Indicator, {
    count: childLength,
    currentIndex: currentIndex,
    className: styles.indicator,
    onChange: handleChange
  }));
};

export default Transform;